import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-100 py-6 text-center text-sm text-gray-600">
      <div className="container mx-auto">
        <nav className="flex justify-center space-x-4 mb-4">
          <Link to="/impressum" className="hover:underline">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:underline">
            Datenschutz
          </Link>
          <Link to="/kontakt" className="hover:underline">
            Kontakt
          </Link>
        </nav>
        <p>© 2025 Future Now UG – Alle Rechte vorbehalten.</p>
        {/* Hinweis auf Readdy entfernt */}
      </div>
    </footer>
  );
}